import { BillingCycleConfigurationType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import { ErrorDetails } from "./handleValidationError";

export enum ErrorCode {
  HTTP_MESSAGE_NOT_READABLE = "HTTP_MESSAGE_NOT_READABLE",
  ILLEGAL_ARGUMENT = "ILLEGAL_ARGUMENT",
  REQUEST_BODY_FIELD_VALIDATION_ERROR = "REQUEST_BODY_FIELD_VALIDATION_ERROR",
  REQUEST_BODY_VALIDATION_ERROR = "REQUEST_BODY_VALIDATION_ERROR",
  REQUEST_FILE_SIZE_EXCEEDS_LIMIT = "REQUEST_FILE_SIZE_EXCEEDS_LIMIT",
  REQUEST_PART_MISSING = "REQUEST_PART_MISSING",
  MEDIA_TYPE_NOT_MATCHING_FILE_NAME = "MEDIA_TYPE_NOT_MATCHING_FILE_NAME",
  UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
  METHOD_ARGUMENT_TYPE_MISMATCH = "METHOD_ARGUMENT_TYPE_MISMATCH",
  CONSTRAINT_VIOLATION = "CONSTRAINT_VIOLATION",
  BATCH_UPDATE_ERROR = "BATCH_UPDATE_ERROR",
  REQUEST_PARAMETER_MISSING_ERROR = "REQUEST_PARAMETER_MISSING_ERROR",
  REQUEST_PARAMETER_INVALID = "REQUEST_PARAMETER_INVALID",
  ABSENCE_GROUP_NOT_EXISTS = "ABSENCE_GROUP_NOT_EXISTS",
  ABSENCE_TYPE_ALREADY_ASSIGNED_TO_ABSENCE_GROUP = "ABSENCE_TYPE_ALREADY_ASSIGNED_TO_ABSENCE_GROUP",
  CALENDAR_NOT_EXISTS = "CALENDAR_NOT_EXISTS",
  ABSENCE_TYPE_NOT_EXISTS = "ABSENCE_TYPE_NOT_EXISTS",
  ABSENCE_TYPE_OWNER_MISMATCH = "ABSENCE_TYPE_OWNER_MISMATCH",
  CALENDAR_DUPLICATE_NAME_FOR_OWNER = "CALENDAR_DUPLICATE_NAME_FOR_OWNER",
  CALENDAR_EXCLUDED_DAYS_FOR_DIFFERENT_YEAR = "CALENDAR_EXCLUDED_DAYS_FOR_DIFFERENT_YEAR",
  CALENDAR_ALREADY_ASSIGNED_FOR_YEAR = "CALENDAR_ALREADY_ASSIGNED_FOR_YEAR",
  CALENDAR_BELONGS_TO_DIFFERENT_OWNER = "CALENDAR_BELONGS_TO_DIFFERENT_OWNER",
  CALENDAR_ASSIGNED_TO_ABSENCE_REQUESTS = "CALENDAR_ASSIGNED_TO_ABSENCE_REQUESTS",
  CALENDAR_ASSIGNED_TO_EMPLOYEES = "CALENDAR_ASSIGNED_TO_EMPLOYEES",
  CALENDAR_ASSIGNED_TO_ACTIVE_EMPLOYEES = "CALENDAR_ASSIGNED_TO_ACTIVE_EMPLOYEES",
  CALENDAR_INACTIVE = "CALENDAR_INACTIVE",
  CALENDAR_FOR_PAST_YEAR = "CALENDAR_FOR_PAST_YEAR",
  ABSENCE_TYPE_NOT_REPLACEABLE = "ABSENCE_TYPE_NOT_REPLACEABLE",
  DUPLICATED_PATTERN = "DUPLICATED_PATTERN",
  ABSENCE_GROUP_OWNER_MISMATCH = "ABSENCE_GROUP_OWNER_MISMATCH",
  ABSENCE_GROUP_INACTIVE = "ABSENCE_GROUP_INACTIVE",
  PARENT_ABSENCE_TYPE_IS_A_CHILD = "PARENT_ABSENCE_TYPE_IS_A_CHILD",
  ABSENCE_TYPE_HAS_CHILDREN = "ABSENCE_TYPE_HAS_CHILDREN",
  PARENT_ABSENCE_TYPE_INCOMPATIBLE = "PARENT_ABSENCE_TYPE_INCOMPATIBLE",
  CHILD_ABSENCE_TYPE_INCOMPATIBLE = "CHILD_ABSENCE_TYPE_INCOMPATIBLE",
  CHILD_ABSENCE_TYPE_ACTIVE_WHEN_PARENT_INACTIVE = "CHILD_ABSENCE_TYPE_ACTIVE_WHEN_PARENT_INACTIVE",
  OPTION_NOT_EDITABLE = "OPTION_NOT_EDITABLE",
  EMPLOYEE_NOT_EXISTS = "EMPLOYEE_NOT_EXISTS",
  EMPLOYEE_NOT_ASSIGNED_TO_ABSENCE_TYPE = "EMPLOYEE_NOT_ASSIGNED_TO_ABSENCE_TYPE",
  PATTERN_BELONGS_TO_DIFFERENT_OWNER = "PATTERN_BELONGS_TO_DIFFERENT_OWNER",
  MULTIPLE_PATTERNS_FOR_ABSENCE_TYPE = "MULTIPLE_PATTERNS_FOR_ABSENCE_TYPE",
  PATTERN_DOES_NOT_EXIST = "PATTERN_DOES_NOT_EXIST",
  PATTERN_TOO_SMALL = "PATTERN_TOO_SMALL",
  NOT_ENOUGH_TIME_AVAILABLE = "NOT_ENOUGH_TIME_AVAILABLE",
  REQUESTED_TIME_IN_TOO_OLD_BILLING_CYCLE = "REQUESTED_TIME_IN_TOO_OLD_BILLING_CYCLE",
  REQUESTER_NOT_ENTITLED = "REQUESTER_NOT_ENTITLED",
  MISSING_CALENDAR_FOR_REQUESTED_TIME = "MISSING_CALENDAR_FOR_REQUESTED_TIME",
  ABSENCE_TYPE_NOT_ACTIVE = "ABSENCE_TYPE_NOT_ACTIVE",
  ABSENCE_REQUEST_NOT_EXISTS = "ABSENCE_REQUEST_NOT_EXISTS",
  ABSENCE_REQUEST_ALREADY_CANCELLED = "ABSENCE_REQUEST_ALREADY_CANCELLED",
  ABSENCE_REQUEST_INVALID_APPROVER = "ABSENCE_REQUEST_INVALID_APPROVER",
  ABSENCE_REQUEST_INVALID_REJECTER = "ABSENCE_REQUEST_INVALID_REJECTER",
  ABSENCE_REQUEST_INVALID_CANCELLER = "ABSENCE_REQUEST_INVALID_CANCELLER",
  ABSENCE_REQUEST_DOES_NOT_EXIST = "ABSENCE_REQUEST_DOES_NOT_EXIST",
  ABSENCE_REQUEST_NOT_EDITABLE = "ABSENCE_REQUEST_NOT_EDITABLE",
  EMPLOYEE_HAS_REQUESTS_FOR_FUTURE_BILLING_CYCLES = "EMPLOYEE_HAS_REQUESTS_FOR_FUTURE_BILLING_CYCLES",
  ABSENCE_TIME_NOT_COMPATIBLE = "ABSENCE_TIME_NOT_COMPATIBLE",
  BILLING_CYCLE_TYPE_INCOMPATIBLE = "BILLING_CYCLE_TYPE_INCOMPATIBLE",
  PATTERN_ABSENCE_TYPE_MISMATCH = "PATTERN_ABSENCE_TYPE_MISMATCH",
  ABSENCE_TYPE_BELONGS_TO_DIFFERENT_OWNER = "ABSENCE_TYPE_BELONGS_TO_DIFFERENT_OWNER",
  APPROVER_NOT_ENTITLED = "APPROVER_NOT_ENTITLED",
  APPROVER_REQUIRED = "APPROVER_REQUIRED",
  ATTACHMENT_REQUIRED = "ATTACHMENT_REQUIRED",
  ATTACHMENT_ALREADY_ASSIGNED_TO_REQUEST = "ATTACHMENT_ALREADY_ASSIGNED_TO_REQUEST",
  ATTACHMENT_ALREADY_ASSIGNED_TO_DIFFERENT_REQUEST = "ATTACHMENT_ALREADY_ASSIGNED_TO_DIFFERENT_REQUEST",
  ATTACHMENT_WITH_DIFFERENT_REQUESTER = "ATTACHMENT_WITH_DIFFERENT_REQUESTER",
  JUSTIFICATION_REQUIRED = "JUSTIFICATION_REQUIRED",
  HOUR_ABSENCE_REQUESTS_NOT_ALLOWED = "HOUR_ABSENCE_REQUESTS_NOT_ALLOWED",
  MULTIPLE_ABSENCE_REQUESTS_PER_DAY_NOT_ALLOWED = "MULTIPLE_ABSENCE_REQUESTS_PER_DAY_NOT_ALLOWED",
  REPLACER_FROM_DIFFERENT_STRUCTURE = "REPLACER_FROM_DIFFERENT_STRUCTURE",
  REPLACER_INVALID = "REPLACER_INVALID",
  REPLACER_REQUIRED = "REPLACER_REQUIRED",
  REPLACER_ABSENT = "REPLACER_ABSENT",
  SUBMIT_LIMITATIONS_VIOLATION = "SUBMIT_LIMITATIONS_VIOLATION",
  MISSING_ATTACHMENT = "MISSING_ATTACHMENT",
  ABSENCE_REQUEST_INVALID_CORRECTION_REQUESTER = "ABSENCE_REQUEST_INVALID_CORRECTION_REQUESTER",
  ABSENCE_REQUEST_UNMODIFIABLE = "ABSENCE_REQUEST_UNMODIFIABLE",
  ABSENCE_REQUEST_INVALID_STATUS = "ABSENCE_REQUEST_INVALID_STATUS",
  COMMENT_NOT_ALLOWED = "COMMENT_NOT_ALLOWED",
  CUSTOM_FIELDS_NOT_EXIST = "CUSTOM_FIELDS_NOT_EXIST",
  CUSTOM_FIELD_VALUES_INVALID = "CUSTOM_FIELD_VALUES_INVALID",
  MANDATORY_CUSTOM_FIELD_VALUES_MISSING = "MANDATORY_CUSTOM_FIELD_VALUES_MISSING",
  ABSENCE_REQUEST_IMPORTED_TOO_OLD = "ABSENCE_REQUEST_IMPORTED_TOO_OLD",
  BILLING_CYCLE_TOO_OLD = "BILLING_CYCLE_TOO_OLD",
  NAME_ALREADY_EXISTS = "NAME_ALREADY_EXISTS",
  REQUESTED_DAY_ABSENCE_TIME_NOT_COMPATIBLE_WITH_HOUR_ABSENCE_TIME = "REQUESTED_DAY_ABSENCE_TIME_NOT_COMPATIBLE_WITH_HOUR_ABSENCE_TIME",
  REQUESTED_HOUR_ABSENCE_TIME_NOT_COMPATIBLE_WITH_DAY_ABSENCE_TIME = "REQUESTED_HOUR_ABSENCE_TIME_NOT_COMPATIBLE_WITH_DAY_ABSENCE_TIME",
  ABSENCE_GROUP_PRESENCE_TYPE_MISMATCH = "ABSENCE_GROUP_PRESENCE_TYPE_MISMATCH",
}

/**
 * Returns a custom error message template based on the provided error code
 * @param errorCode The error code
 * @returns The error message template
 */
export const getCustomErrorMessage = (errorCode: ErrorCode): string => {
  switch (errorCode) {
    case ErrorCode.REQUEST_FILE_SIZE_EXCEEDS_LIMIT:
      return "Rozmiar pliku przekracza dozwolony limit.";
    case ErrorCode.ABSENCE_GROUP_NOT_EXISTS:
      return "Grupa nieobecności/obecności nie istnieje. Zweryfikuj dane.";
    case ErrorCode.ABSENCE_TYPE_ALREADY_ASSIGNED_TO_ABSENCE_GROUP:
      return "Nie możesz zmienić rodzaju grupy lub jej dezaktywować gdy ma przypisane szablony.";
    case ErrorCode.CALENDAR_NOT_EXISTS:
      return "Kalendarz nie istnieje. Zweryfikuj dostępne kalendarze.";
    case ErrorCode.ABSENCE_TYPE_NOT_EXISTS:
      return "Szablon wniosku nie istnieje. Zweryfikuj dostepne szablony.";
    case ErrorCode.ABSENCE_TYPE_OWNER_MISMATCH:
      return "Brak dostępu do szablonu wniosku.";
    case ErrorCode.NAME_ALREADY_EXISTS:
      return "Wniosek o wskazanej nazwie już istnieje. Wybierz inną nazwę, aby utworzyć szablon.";
    case ErrorCode.CALENDAR_DUPLICATE_NAME_FOR_OWNER:
      return "Nazwa kalendarza już istnieje. Wprowadź unikalną nazwę.";
    case ErrorCode.CALENDAR_EXCLUDED_DAYS_FOR_DIFFERENT_YEAR:
      return "Wskazane daty są niezgodnie z wybranym rokiem kalendarza. Zweryfikuj zakres czasu oraz rok tworzonego kalendarza.";
    case ErrorCode.CALENDAR_ALREADY_ASSIGNED_FOR_YEAR:
      return "Pracownik ma już dodany kalendarz na dany rok.";
    case ErrorCode.CALENDAR_BELONGS_TO_DIFFERENT_OWNER:
      return "Brak dostępu do kalendarza.";
    case ErrorCode.CALENDAR_ASSIGNED_TO_ABSENCE_REQUESTS:
      return "Operacja niemożlwa, w oparciu o kalendarz zostały już złożone wnioski. W celu usunięcia kalendarza edytuj złożone wnioski.";
    case ErrorCode.CALENDAR_ASSIGNED_TO_EMPLOYEES:
      return "Operacja niemożliwa, kalendarz został przypisany do pracowników. W celu usunięcia kalendarza edytuj jego przypisania.";
    case ErrorCode.CALENDAR_ASSIGNED_TO_ACTIVE_EMPLOYEES:
      return "Operacja niemożliwa, kalendarz został przypisany do aktywnych pracowników. W celu wprowadzenia zmian edytuj jego przypisania.";
    case ErrorCode.CALENDAR_INACTIVE:
      return "Kalendarz jest nieaktywny. Wybierz aktywny kalendarz.";
    case ErrorCode.CALENDAR_FOR_PAST_YEAR:
      return "Kalendarz dotyczy lat ubiegłych. Zweryfikuj kalendarze.";
    case ErrorCode.ABSENCE_TYPE_NOT_REPLACEABLE:
      return "Operacja niemożliwa, w oparciu o szablon zostały już złożone wnioski lub przypisano wzorce do pracowników. Zweryfikuj ustawienia i/lub złożone wnioski.";
    case ErrorCode.DUPLICATED_PATTERN:
      return "Wprowadzony wzorzec już istnieje.";
    case ErrorCode.ABSENCE_GROUP_OWNER_MISMATCH:
      return "Brak dostępu do wybranej grupy nieobecności/obecności.";
    case ErrorCode.ABSENCE_GROUP_INACTIVE:
      return "Wybrana grupa nieobecności/obecności jest nieaktywna. Wybierz aktywną grupę.";
    case ErrorCode.PARENT_ABSENCE_TYPE_IS_A_CHILD:
      return "Szablon wniosku jest już przypisany jako wniosek podrzędny. Zweryfikuj przypisania.";
    case ErrorCode.ABSENCE_TYPE_HAS_CHILDREN:
      return "Szablon wniosku ma już przypisane wnioski podrzędne.";
    case ErrorCode.PARENT_ABSENCE_TYPE_INCOMPATIBLE:
    case ErrorCode.CHILD_ABSENCE_TYPE_INCOMPATIBLE:
      return "Cechy szablonu wniosku podrzędnego i nadrzędnego powinny być spójne. Zwerifykuj ustawienia wniosków.";
    case ErrorCode.CHILD_ABSENCE_TYPE_ACTIVE_WHEN_PARENT_INACTIVE:
      return "W celu aktywacji wniosku podrzędnego należy najpierw aktywować wniosek nadrzędny.";
    case ErrorCode.OPTION_NOT_EDITABLE:
      return "Brak możliwości edycji szablonu wniosku, zmiana  okresu rozliczeniowego nie jest możliwa.";
    case ErrorCode.EMPLOYEE_NOT_EXISTS:
      return "Pracownik nie istnieje.";
    case ErrorCode.EMPLOYEE_NOT_ASSIGNED_TO_ABSENCE_TYPE:
      return "Pracownik nie jest przypisany do szablonu wniosku.";
    case ErrorCode.PATTERN_BELONGS_TO_DIFFERENT_OWNER:
      return "Brak dostępu do wybranego wzorca.";
    case ErrorCode.MULTIPLE_PATTERNS_FOR_ABSENCE_TYPE:
      return "Przypisanie wielu wzorców nie jest możliwe. Wybierz jeden wzorzec.";
    case ErrorCode.PATTERN_DOES_NOT_EXIST:
      return "Wskazany wzorzec nie istnieje.";
    case ErrorCode.PATTERN_TOO_SMALL:
      return "Edycja wzorca nie jest możliwa, pracownik wykorzystał zbyt dużą liczbę dni/godzin. W celu kontunuacji edytuj wnioski złożone przez pracownika.";
    case ErrorCode.NOT_ENOUGH_TIME_AVAILABLE:
      return "Nie można kontynuować, zbyt mała liczba dostępnych dni/godzin. Skoryguj wybór.";
    case ErrorCode.REQUESTED_TIME_IN_TOO_OLD_BILLING_CYCLE:
      return "Wskazano daty obejmujące poprzedni okres rozliczeniowy. Zweryfikuj dane.";
    case ErrorCode.REQUESTER_NOT_ENTITLED:
      return "Wskazane daty znajdują się w minionym okresie rozliczeniowym. Zweryfikuj dane.";
    case ErrorCode.MISSING_CALENDAR_FOR_REQUESTED_TIME:
      return "W wybranym okresie nie został wskazany kalendarz.  Zweryfikuj przypisane kalendarzy.";
    case ErrorCode.ABSENCE_TYPE_NOT_ACTIVE:
      return "Szablon wniosku jest nieaktywny. Zweryfikuj dane.";
    case ErrorCode.ABSENCE_REQUEST_NOT_EXISTS:
    case ErrorCode.ABSENCE_REQUEST_DOES_NOT_EXIST:
      return "Szablon wniosku nie istnieje. Zweryfikuj dane.";
    case ErrorCode.ABSENCE_REQUEST_ALREADY_CANCELLED:
      return "Wniosek został już anulowany.";
    case ErrorCode.ABSENCE_REQUEST_INVALID_APPROVER:
      return "Brak uprawnień: akceptacja wniosku.";
    case ErrorCode.ABSENCE_REQUEST_INVALID_REJECTER:
      return "Brak uprawnień: odrzucenie wniosku.";
    case ErrorCode.ABSENCE_REQUEST_INVALID_CANCELLER:
      return "Brak uprawnień: anulacja wniosku.";
    case ErrorCode.ABSENCE_REQUEST_NOT_EDITABLE:
      return "Nie można edytować wniosku, skontaktuj się z działem HR.";
    case ErrorCode.EMPLOYEE_HAS_REQUESTS_FOR_FUTURE_BILLING_CYCLES:
      return "Zmiana wzorca nie jest możliwa, złożono wniosek na przyszły okres rozliczeniowy. W celu kontunuacji edytuj wnioski na przyszłe okresy rozliczeniowe.";
    case ErrorCode.ABSENCE_TIME_NOT_COMPATIBLE:
      return "Wskazany czas trwania wniosku jest niezgodny z szablonem wniosku. Zweryfikuj dane.";
    case ErrorCode.BILLING_CYCLE_TYPE_INCOMPATIBLE:
      return "Modyfikowany okres rozliczeniowy nie jest zgodny z ustawieniami szablonu wniosku. Zweryfikuj ustawienia.";
    case ErrorCode.PATTERN_ABSENCE_TYPE_MISMATCH:
      return "Podany wzorzec jest niezgodny z szablonem wniosku. Zweryfikuj ustawienia.";
    case ErrorCode.APPROVER_NOT_ENTITLED:
      return "Użytkownik nie jest uprawniony do akceptacji wnosku. Zmień wybór.";
    case ErrorCode.APPROVER_REQUIRED:
      return "Wymagane wskazanie akceptana wniosku.";
    case ErrorCode.ATTACHMENT_REQUIRED:
      return "Załacznik jest wymagany.";
    case ErrorCode.ATTACHMENT_ALREADY_ASSIGNED_TO_REQUEST:
    case ErrorCode.ATTACHMENT_ALREADY_ASSIGNED_TO_DIFFERENT_REQUEST:
    case ErrorCode.ATTACHMENT_WITH_DIFFERENT_REQUESTER:
      return "Błąd systemu, sprobuj dodać załaczniki ponownie.";
    case ErrorCode.JUSTIFICATION_REQUIRED:
      return "Uzasadnienie jest wymagane.";
    case ErrorCode.HOUR_ABSENCE_REQUESTS_NOT_ALLOWED:
      return "Złożenie wniosku o nieobecność godzinową nie jest możliwe.";
    case ErrorCode.MULTIPLE_ABSENCE_REQUESTS_PER_DAY_NOT_ALLOWED:
      return "Nie można złozyć wielu nieobecności na jeden dzień.";
    case ErrorCode.REPLACER_FROM_DIFFERENT_STRUCTURE:
      return "Wskazany zastepca nie należy do tej samej struktury. Zmień wybór.";
    case ErrorCode.REPLACER_INVALID:
      return "Wskazana osoba zastepujaca nie jest możliwa do wybrania. Zmień wybór.";
    case ErrorCode.REPLACER_REQUIRED:
      return "Wymagane wskazanie osoby zastępujacej.";
    case ErrorCode.REPLACER_ABSENT:
      return "Wskazana osoba zastępująca jest nieobecna w terminie składanego wniosku. Zmień wybór.";
    case ErrorCode.SUBMIT_LIMITATIONS_VIOLATION:
      return "Złożenie wniosku na wybrany termin nie jest możliwe. Skontaktuj się z administratorem.";
    case ErrorCode.MISSING_ATTACHMENT:
      return "Wskazany załącznik nie istnieje.";
    case ErrorCode.ABSENCE_REQUEST_INVALID_CORRECTION_REQUESTER:
      return "Wskazany wniosek nie może zostać zgłoszony do poprawy.";
    case ErrorCode.ABSENCE_REQUEST_UNMODIFIABLE:
      return "Wskazany wniosek nie może zostać edytowany/zgłoszony do poprawy. Zweryfikuj ustawienia - w przypadku wniosków już złożonych, by nadać nową cechę konieczne może być konieczne odrzucenie wniosku i złożenie nowego.";
    case ErrorCode.ABSENCE_REQUEST_INVALID_STATUS:
      return "Operaja niemożliwa - wniosek posiada nieodpowiedni status.";
    case ErrorCode.COMMENT_NOT_ALLOWED:
      return "Wprowadzenie komentarza nie jest możliwe.";
    case ErrorCode.CUSTOM_FIELDS_NOT_EXIST:
      return "Błąd systemu. Pola nie istnieją.";
    case ErrorCode.CUSTOM_FIELD_VALUES_INVALID:
      return "Błąd systemu. Skontaktuj się z administratorem.";
    case ErrorCode.MANDATORY_CUSTOM_FIELD_VALUES_MISSING:
      return "Uzupełnij brakujące pola.";
    case ErrorCode.ABSENCE_TYPE_BELONGS_TO_DIFFERENT_OWNER:
      return "Wystąpił błąd systemu. Skontaktuj się z administratorem.";
    case ErrorCode.ABSENCE_REQUEST_IMPORTED_TOO_OLD:
    case ErrorCode.BILLING_CYCLE_TOO_OLD:
      return "Edycja niemożliwa, wniosek można edytować jedynie w roku bieżącym lub poprzednim.";
    case ErrorCode.ABSENCE_GROUP_PRESENCE_TYPE_MISMATCH:
      return "Szablon został źle przypisany do grupy, zmień grupę.";
    case ErrorCode.HTTP_MESSAGE_NOT_READABLE:
    case ErrorCode.ILLEGAL_ARGUMENT:
    case ErrorCode.REQUEST_BODY_FIELD_VALIDATION_ERROR:
    case ErrorCode.REQUEST_BODY_VALIDATION_ERROR:
    case ErrorCode.REQUEST_PART_MISSING:
    case ErrorCode.MEDIA_TYPE_NOT_MATCHING_FILE_NAME:
    case ErrorCode.UNSUPPORTED_MEDIA_TYPE:
    case ErrorCode.METHOD_ARGUMENT_TYPE_MISMATCH:
    case ErrorCode.CONSTRAINT_VIOLATION:
    case ErrorCode.BATCH_UPDATE_ERROR:
    case ErrorCode.REQUEST_PARAMETER_MISSING_ERROR:
    case ErrorCode.REQUEST_PARAMETER_INVALID:
    default:
      return "Wystąpił błąd systemu.";
  }
};

export const getDetailedErrorMessage = (err: {
  code: string;
  message: string;
  details: ErrorDetails;
}) => {
  if (
    err.code ===
    ErrorCode.REQUESTED_DAY_ABSENCE_TIME_NOT_COMPATIBLE_WITH_HOUR_ABSENCE_TIME
  ) {
    if (
      err.details.billingCycleType === BillingCycleConfigurationType.Monthly
    ) {
      return "Wniosek na ten miesiąc musi być złożony w terminie godzinowym. Zmień termin na godzinowy, aby złożyć wniosek.";
    }

    if (err.details.billingCycleType === BillingCycleConfigurationType.Yearly) {
      return "Wniosek na ten rok musi być złożony w terminie godzinowym. Zmień termin na godzinowy, aby złożyć wniosek.";
    }

    return "Wniosek musi być złożony w terminie godzinowym. Zmień termin na godzinowy, aby złożyć wniosek.";
  }

  if (
    err.code ===
    ErrorCode.REQUESTED_HOUR_ABSENCE_TIME_NOT_COMPATIBLE_WITH_DAY_ABSENCE_TIME
  ) {
    if (
      err.details.billingCycleType === BillingCycleConfigurationType.Monthly
    ) {
      return "Wniosek na ten miesiąc musi być złożony w terminie dziennym. Zmień termin na dzienny, aby złożyć wniosek.";
    }

    if (err.details.billingCycleType === BillingCycleConfigurationType.Yearly) {
      return "Wniosek na ten rok musi być złożony w terminie dziennym. Zmień termin na dzienny, aby złożyć wniosek.";
    }

    return "Wniosek musi być złożony w terminie dziennym. Zmień termin na dzienny, aby złożyć wniosek.";
  }

  return null;
};
